import { initializeApp } from "firebase/app"
import { 
  getDatabase, ref, get 
} from "firebase/database"
import {
  getAuth,
  signInWithCustomToken,
  signOut,
} from "firebase/auth"

import ApiService from './ApiService'

class FirebaseService {
  constructor () {
    console.log('CONSTRUCT FirebaseService')
    this.fbDatabase = null
    this.path = `users/$cpf/telessaude/sala/$cpf`
    this.setFirebaseConfig()
    this.ApiService = new ApiService()
  }

  /**
   * Configura a conexão com o Firebase.
   */
  setFirebaseConfig () {
    const config = {
      apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
      authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
      databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
      projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.VUE_APP_FIREBASE_APP_ID
    }
    const firebaseApp = initializeApp(config)
    this.fbDatabase = getDatabase(firebaseApp)
    this.fbAuth = getAuth(firebaseApp)
  }

  /**
   * Obtém os dados de chamada da sala associada ao CPF no Firebase, apenas uma vez.
   * @async
   * @param {string} cpf - CPF do usuário (somente números).
   * @returns {Promise<Object>} - Um objeto com os dados da chamada e 
   * o estado de permissão de entrada na sala
   * @throws {Error} - Lança um erro caso a busca dos dados falhe.
   */
  async fetchRoomCallByCpf (cpf) {
    const formattedCpf = cpf.replace(/[.-]/g, '');
    const path = this.path.replace(/\$cpf/g, formattedCpf);
    const roomRef = ref(this.fbDatabase, path);

    try {
      const snapshot = await get(roomRef);
      const currentData = snapshot.val();
      
      if (currentData?.call) {
        return {
          ...currentData.call,
          canEnterRoom: this._determineRoomAccess(currentData.call.patientCallStatus)
        };
      } else {
        return { 
          patientCallStatus: null,
          canEnterRoom: this._determineRoomAccess(null)
        };
      }
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
      throw error;
    }
  }

  /**
   * Determina se o usuário pode entrar na sala com base no status da chamada.
   * @private
   * @param {string|null} status - O status atual da chamada do paciente.
   * @returns {boolean} - `true` se o usuário puder entrar na sala, `false` caso contrário.
   */
   _determineRoomAccess(status) {
    if (status === null) {
      return true
    }
    switch (status) {
      case 'CANCELLED': 
      case 'REJECTED': 
      case 'TIMED_OUT': 
      case 'CLOSED': 
      case 'CANCEL': 
        return true;
      case 'ACCEPTED': 
      case 'STARTED': 
        return false;
      default: 
        return false;
    }
  }

  async authenticateWithCustonToken(firebaseToken) {
    return signInWithCustomToken(
      this.fbAuth,
      firebaseToken,
    );
  }

  async logout() {
    await signOut(this.fbAuth);
  }
}

export default FirebaseService